<!--
  Collector Mappers sheet: a mat-paginator-driven Handsontable (Table tab) plus
  Pivot and History tabs. Paging, search and the account filter all funnel through
  the component's PaginationDataSource (applyFilters / onPage) — the grid itself
  never queries the server. Rows are added via the toolbar's Add Row button
  (spare rows are disabled).
-->
<div class="page">
  <mat-tab-group disableRipple class="dialog-table" mat-stretch-tabs="false"
                 (selectedTabChange)="onTabChange($event)">
    <mat-tab label="Table" [hidden]="!hot || !hot.instance">
      <div class="row utils-bar justify-start hot-utils">
        <div class="row table-filter space-between">
          <!-- Gate the search/account/add-row controls on hot.instance (set once at
               table init, never per-query) so <account-filter> isn't destroyed and
               re-mounted across page loads — a fresh instance would reset its
               visible selection to the default active account. -->
          <div *ngIf="hot && hot.instance" class="row center min-height">
            <utils-bar #utils_bar
                       [search]="true"
                       [disabled]="downloadInProgress"
                       (searchValueSubmitted)="onSearchSubmitted($event)"
                       (searchCleared)="onSearchCleared()">
            </utils-bar>
            <!-- No [initialAccountIds]: account-filter defaults its own selection to
                 [activeAccountId] via AccountService — matching what we already filter
                 the table by in ngOnInit. Passing initialAccountIds here would couple
                 account-filter's selectedAccountIds to this component's array, and the
                 shared reference breaks mat-select multi-mode's one-way [value] binding
                 (the tick disappears when toggling other accounts).
                 Disabled while the sheet is dirty: onAccountsSelected() blocks the
                 server-side filter when there are unsaved edits, so without this the
                 mat-select would show the newly-picked accounts while the applied
                 filter still holds the previous selection. Disabling keeps the visible
                 selection in sync with what's actually applied. -->
            <account-filter [multiple]="true"
                            (accountFilterEmitter)="onAccountsSelected($event)"
                            [disabled]="downloadInProgress || hasUnsavedChanges"></account-filter>
            <button mat-stroked-button class="hot-insert-button" matTooltip="Insert new row"
                    [disabled]="downloadInProgress || loading"
                    (click)="addSpareRow()">
              <i class="fa fa-plus"></i>&nbsp;Add row
            </button>
          </div>
          <div class="row min-height" style="align-items: center">
            <!-- Grand total across all accessible accounts (refreshTotalRowCount) —
                 independent of the paginator's range label, which shows the current
                 filter's total (paginator.length from meta.count). -->
            <div *ngIf="totalRowCount != null" class="hot-meta-count">{{totalRowCount}} total across all accounts</div>
            <!-- [hidden] (not *ngIf) so the @ViewChild resolves in ngAfterViewInit.
                 Disabled while dirty: a page change reloads the grid via onPage's
                 loadData(), which would discard unsaved edits with no guard in
                 between (matches the account-filter convention above). -->
            <mat-paginator [pageSize]="page_size"
                           [pageSizeOptions]="page_size_options"
                           [showFirstLastButtons]="true"
                           [hidden]="!firstPageReady"
                           [disabled]="loading || downloadInProgress || hasUnsavedChanges"
                           class="hot-paginator">
            </mat-paginator>
          </div>
        </div>
      </div>
      <div class="md-padding" style="position:relative;">
        <div *ngIf="loading" class="app-loading app-loading-component">
          <div class="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div (window:resize)="hot.onResize($event)" [style.height.px]="hot.window_height">
          <div #hot_anchor [id]="hot.handson_id" class="hot-template-anchor">
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab *ngIf="hot && hot.instance" label="Pivot">
      <ng-template matTabContent>
        <pivot-view *ngIf="fullDatasetLoaded && !pivotLoadFailed" [hot]="hot" [data]="pivotData"
                    [extraColumns]="pivotExtraColumns"></pivot-view>
        <div *ngIf="pivotLoadFailed" class="md-padding pivot-load-error">
          Failed to load the pivot dataset. Switch away from the Pivot tab and back to retry.
        </div>
        <div *ngIf="!fullDatasetLoaded && !pivotLoadFailed" class="md-padding app-loading app-loading-component">
          <div class="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab *ngIf="hot && hot.instance" label="History">
      <ng-template matTabContent>
        <div style="width: 100%; overflow:auto;">
          <history-table [hot]="hot"></history-table>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
